import { AwsRum, AwsRumConfig } from "aws-rum-web";
import { AppSettings } from "./AppSettings";
import { Auth } from "aws-amplify";

export let cloudWatchRumClient: AwsRum;

// Requires AppSettings to be loaded already
export function initCloudWatchRumClient() {
  try {
    const applicationId = AppSettings().cloudWatchRumConfig.cfnMonitorAppId;
    const applicationVersion = "1.0.0";
    const region = AppSettings().region;
    const config = getCloudWatchRumConfig();

    cloudWatchRumClient = new AwsRum(applicationId, applicationVersion, region, config);
    setCloudWatchRumCredentials(cloudWatchRumClient);
  } catch (e) {
    console.error("Error while init CloudWatch Rum client: ", e);
  }
}

function setCloudWatchRumCredentials(rum: AwsRum) {
  Auth.currentCredentials().then((credentials) => {
    rum.setAwsCredentials(credentials);
  });
}

function getCloudWatchRumConfig(): AwsRumConfig {
  return {
    sessionSampleRate: Number(AppSettings().cloudWatchRumConfig.sessionSampleRate),
    endpoint: AppSettings().cloudWatchRumConfig.endpoint,
    telemetries: AppSettings().cloudWatchRumConfig.telemetries.split(","),
    allowCookies: AppSettings().cloudWatchRumConfig.allowCookies === "true",
    enableXRay: AppSettings().cloudWatchRumConfig.enableXRay === "true",
  };
}
